import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Hero() {
  return <section data-section-id="180376" id="hero-preise" className="px-3 sm:px-4 pt-3 pb-3">
  <div className="mx-auto w-full bg-[#141414] rounded-[1rem] min-h-[70vh] flex flex-col justify-end">
    <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 pb-16">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-end">
        {/* Left: Heading */}
        <div>
          <span className="mb-5 inline-block rounded-full bg-white/10 border border-white/20 px-5 py-2 text-sm font-semibold uppercase tracking-widest text-white/60">
            Faire Preise & Volle Flexibilität
          </span>
          <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold tracking-tight leading-[1.05] text-white">
            Gutes Arbeiten muss nicht teuer sein.
          </h1>
        </div>
        {/* Right: Text */}
        <div>
          <p className="text-lg text-white/60 leading-relaxed">
            Vom Coworking-Tagesticket bis zum eigenen Teambüro. Bei uns weißt du vorher, was du zahlst — ohne versteckte Kosten und ohne Kleingedrucktes. WLAN, Küche und ein kostenloser Parkplatz sind bei jeder Option dabei.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>;
}